import { StoresList } from '@/models/enums/app/StoresList'
import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'
import type { SousDomaine } from '@/models/interfaces/SousDomaine'
import { SousDomaineService } from '@/services/sousDomaine/SousDomaineService'

export const useSousDomaineStore = defineStore(StoresList.SOUS_DOMAINE, () => {
  const sousDomaineList: Ref<SousDomaine[]> = ref([])

  async function getAll(): Promise<void> {
    if (sousDomaineList.value.length === 0) {
      sousDomaineList.value = await SousDomaineService.getAll()
    }
  }

  function getByDomaineId(domaineId: number): SousDomaine[] {
    return sousDomaineList.value.filter((sousDomaine) => sousDomaine.fkDomaineId === domaineId)
  }

  return {
    sousDomaineList,
    getAll,
    getByDomaineId,
  }
})
